/* La Cigogne Rose · panier 02-11 (2026-11-02). « Va bien avec » (snippets/lcr-va-avec) : ajout SANS quitter le tiroir.
   Même mécanique que assets/product-form.js du thème :
     1. on émet un CartLinesUpdateEvent (action « add ») portant une promesse différée ;
     2. POST sur Theme.routes.cart_add_url (/cart/add.js) avec `sections` = les cart-items-component présents ;
     3. on relit /cart.json et on résout la promesse avec { cart, detail: { sections, … } }.
   cart-items-component écoute cet événement et re-rend le tiroir (et la page /cart) avec les sections reçues :
   ce bloc est donc recalculé côté serveur, en Liquid, à chaque ajout.
   Délégation sur document : le tiroir est remplacé à chaque changement, aucun écouteur n'est perdu.
   Sans JavaScript (ou si le module ne charge pas), le formulaire poste normalement vers /cart/add → page /cart. */
import { CartLinesUpdateEvent } from '@shopify/events';

document.addEventListener('submit', async (e) => {
  const form = e.target;
  if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-lcr-assortis')) return;
  e.preventDefault();
  const btn = form.querySelector('button');
  if (btn) { btn.disabled = true; btn.dataset.txt = btn.textContent; btn.textContent = '…'; }

  const fd = new FormData(form);
  const ids = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
  if (ids.length) fd.append('sections', ids.join(','));
  const id = String(fd.get('id'));
  const differe = CartLinesUpdateEvent.createPromise();
  form.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add', context: 'product', lines: [{ merchandiseId: id, quantity: 1 }], promise: differe.promise,
  }));

  try {
    const r = await fetch(Theme.routes.cart_add_url, {
      method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd,
    }).then((x) => x.json());
    const panier = await fetch(`${Theme.routes.cart_url}.json`, { headers: { Accept: 'application/json' } }).then((x) => x.json());
    differe.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(panier),
      detail: {
        items: panier.items, source: 'lcr-assortis', sourceId: 'lcr-assortis', itemCount: 1,
        sections: r.status ? undefined : r.sections, didError: Boolean(r.status),
      },
    });
    if (r.status && btn) { btn.textContent = 'Indisponible'; return; }
  } catch (err) {
    console.error(err);
    differe.reject(err);
    form.removeAttribute('data-lcr-assortis');
    form.submit(); // repli : ajout classique, page /cart
    return;
  }
  if (btn && btn.isConnected) { btn.disabled = false; btn.textContent = btn.dataset.txt || 'Ajouter'; }
});
